"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appInsights = exports.reactPlugin = void 0;
/*
 * © 2022 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
const applicationinsights_react_js_1 = require("@microsoft/applicationinsights-react-js");
const history_1 = require("history");
const telemetryWhitelist = [
    "sa1manatee1prs.z33.web.core.windows.net",
    "sentinel.renishawcentral.com",
    "sandbox.renishawcentral.com",
    "vanguard.renishawcentral.com",
];
const hostname = window.location.hostname;
const browserHistory = (0, history_1.createHashHistory)({ hashType: "hashbang" });
exports.reactPlugin = new applicationinsights_react_js_1.ReactPlugin();
exports.appInsights = new applicationinsights_web_1.ApplicationInsights({
    config: {
        // TODO: Move this key to a config file
        instrumentationKey: "bc5bdd72-51d3-4e80-b9cc-e90e9e5ecb33",
        // @ts-ignore
        extensions: [exports.reactPlugin],
        extensionConfig: {
            [exports.reactPlugin.identifier]: { history: browserHistory },
        },
        disableTelemetry: !telemetryWhitelist.includes(hostname),
        isRetryDisabled: true,
    },
});
exports.appInsights.loadAppInsights();
//# sourceMappingURL=AppInsights.js.map